import axios from "axios";
import LineChart from 'echarts-for-react';
import React, { PureComponent,useState,useEffect } from 'react';

// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function Lines(){
  let [series,setSeries]=useState([])
  let [graphData,setData]=useState([
    {

      day: 'January',
      
    },
    {
      day: 'February',
      
    },
    {
      day: 'March',
      
    },
    {
      day: 'April',
      
    },
    {
      day: 'May',
      
    },
    {
      day: 'June',
      
    },
    {
      day: 'July',
      
    },
    {
      day: 'August',
      
    },
    {
      day: 'September',
      
    },
    {
      day: 'October',
      
    },
    {
      day: 'November',
      
    },
    {
      day: 'December',
      
    },
  ])
  
  let color=["#ee4444","#3dd857","#a500fe"]
  const [labels,setLabels]=useState([])
  let months={
    January:"Jan",
    February:"Feb",
    March:"Mar",
    April:"Apr",
    May:"May",
    June:"Jun",
    July:"Jul",
    August:"Aug",
    September:"Sep",
    October:"Oct",
    November:"Nov",
    December:"dec"
  }
  useEffect(()=>{
    let tempGraphData=[...graphData]
      axios.get(process.env.REACT_APP_API_POINT +'DQ-pipeline/pipeline-details-Q2-QTD',{headers:{Authorization: 'Bearer '+sessionStorage.getItem('token')}}).then((data)=>{
        if(data.data.success){
          let tempLabels=[]
          data.data['DQ-Pipeline-Details-Q2 QTD Data'].forEach(element => {
            if(!tempLabels.includes(element['Pipeline Flag'])){
              tempLabels.push(element['Pipeline Flag'])
            }
            
            tempGraphData.forEach((ele)=>{
              if(element['Month']==ele.day){
                ele[element['Pipeline Flag']]=element['QTD Issues Occured']
              }
            })
            setData(tempGraphData)
          
          })
          setLabels(tempLabels)
          

          let tempSeries=[]
          tempLabels.forEach((ele,index)=>{
            let arr={
              data: [],
              type: 'line',
              color:color[index],
              
            }
            tempGraphData.forEach((d)=>{
              if(d[ele]){
                arr.data.push(d[ele])
              }else{
                arr.data.push(0)
              }
            })
           
              tempSeries.push(arr)
            
          })
          setSeries(tempSeries)
        }
      })
     
  },[])

  






    return (<>
   <LineChart height={"20%"}
        option={{
          tooltip:{
            show:true
          },
          xAxis: {
            type: 'category',
            data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul','Aug','Sep','Oct','Nov','Dec']
          },
          yAxis: {
            type: 'value'
          },
          series:series
        }}
      />
  <span className="d-flex justify-content-center text-dark" >{labels.map((label,index)=>{ return <><span className="m-2" style={{backgroundColor:color[index], height:"12px",width:"12px",borderRadius:"5px"}}  /><span className="m-1">{label}</span></>})}</span>

</>
    );
  }


export default Lines;
